"use client";
import { Pencil, Star, Trophy, Gift } from "lucide-react";
import FloatingElements from "./_components/FloatingElements";
import Profile from "./_components/Profile";
import { useNavigate } from "react-router-dom";

const KidsLearningApp = () => {
  const router = useNavigate();

  const handleStartPractice = async () => {
    router("/word-prompt");
  };

  const mainButtons = [
    {
      id: 1,
      title: "Start Practice",
      icon: <Pencil className="w-10 h-10" />,
      color: "from-purple-400 via-pink-400 to-purple-600",
      hoverColor: "from-purple-500 via-pink-500 to-purple-700",
      emoji: "🚀",
      onclick: handleStartPractice,
    },

    {
      id: 3,
      title: "Leaderboard",
      icon: <Trophy className="w-10 h-10" />,
      color: "from-blue-400 via-cyan-400 to-teal-500",
      hoverColor: "from-blue-500 via-cyan-500 to-teal-600",
      emoji: "🏆",
      onclick: () => router("/leaderboard"),
    },
    {
      id: 4,
      title: "My Collectibles",
      icon: <Gift className="w-10 h-10" />,
      color: "from-green-400 via-emerald-400 to-blue-500",
      hoverColor: "from-green-500 via-emerald-500 to-blue-600",
      emoji: "🎁",
      onclick: () => router("/collectables"),
    },
    {
      id: 2,
      title: "Word of the Day",
      subtitle: "Comming Soon !!!",
      icon: <Star className="w-10 h-10" />,
      color: "from-orange-400 via-yellow-400 to-red-500",
      hoverColor: "from-orange-500 via-yellow-500 to-red-600",
      emoji: "✨",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-200 via-purple-200 to-indigo-200 p-6">
      <div className="max-w-4xl mx-auto">
        {/* Header Section */}
        <Profile />
        {/* Main Action Buttons */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {mainButtons.map((button) => (
            <button
              key={button.id}
              onClick={button.onclick}
              className={`group min-h-[190px] relative bg-gradient-to-r ${
                button.color
              } hover:${
                button.hoverColor
              } text-white rounded-3xl p-10 shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-300 overflow-hidden border-4 border-white/30 ${
                button.onclick ? "cursor-pointer" : "cursor-not-allowed"
              }`}
            >
              <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative flex flex-col items-center gap-4 text-center">
                <div className="flex items-center gap-3">
                  <div className="group-hover:rotate-12 group-hover:scale-125 transition-transform duration-300">
                    {button.icon}
                  </div>
                  <div className="text-4xl group-hover:animate-bounce">
                    {button.emoji}
                  </div>
                </div>
                <span className="text-2xl font-bold group-hover:scale-105 transition-transform duration-300">
                  {button.title}
                </span>
                {button.subtitle && (
                  <span className="text-lg text-white/80">
                    {button.subtitle}
                  </span>
                )}
              </div>
              <div className="absolute -right-8 -top-8 w-24 h-24 bg-white/10 rounded-full group-hover:scale-150 transition-transform duration-500"></div>
              <div className="absolute -left-4 -bottom-4 w-16 h-16 bg-white/10 rounded-full group-hover:scale-125 transition-transform duration-700"></div>
            </button>
          ))}
        </div>

        {/* Floating Elements for Fun */}
        <FloatingElements />
      </div>
    </div>
  );
};

export default KidsLearningApp;
